import React, { Component } from 'react'
import Logo from '../common/logo'
import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'

export default class Error extends Component {

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus()
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div id="error_page">
        <AriaMessage message="Navigated to error page" />
        <div className="container header">      
          <Logo />
        </div>
        <Title>Page Not Available</Title>
        <div className="container">
          <h2>The page you are trying to reach is no longer available.</h2>
          <h4>If you need help registering or would like to speak with one of our care specialist please send us an email clientcare@newtopia.com or give us a call at 1-888-639-8181</h4>
        </div>
      </div>
    )
  }
}